export const vi = {
    LEFT: 'Trái: di Chuyển đến ngày trước.',
    RIGHT: 'Phải di Chuyển để vào ngày hôm sau.',
    DOWN: 'Xuống: di Chuyển đến hàng tiếp theo.',
    UP: 'Lên: di Chuyển đến hàng trước đó.',
    PGUP: 'PgUp: di Chuyển tháng trước.',
    PGDOWN: 'PgDown: di Chuyển để tháng tới.',
    HOME: 'Nhà: di Chuyển đến năm trước.',
    END: 'Kết thúc: di Chuyển đến năm tiếp theo.',
    ESC: 'Tối Nay/Gần: đóng lịch.',
    TITLE: 'Bàn Phím Hướng Dẫn'
};
